export default "__VITE_ASSET__DcQN2Pg4__"